<template>
  <div class="product-photo">
    <div class="photo-more">
      <div ref="photo-viewer" class="images-hidden" v-viewer="viewerOptions">
        <img preload v-for="(image, i) in images" :key="i" :src="getImageUrl(image)" :alt="getAlt(i)" loading="lazy"/>
      </div>

      <template v-if="images.length">
        <div v-for="(image, i) in images.slice(0, visibleThumbnails)" class="image" :class="{'active': index === i}">
          <div @click="index = i" class="image-background"
               :style="{'background-image': `url(${getImageUrl(image)})`}">
          </div>
        </div>

        <div v-for="(image, i) in images" class="image image-mobile" :class="{'active': index === i}">
          <div @click="index = i" class="image-background"
               :style="{'background-image': `url(${getImageUrl(image)})`}">
          </div>
        </div>
      </template>

      <div v-else-if="dbConfig.default_product_image" class="image empty">
        <div class="image-background empty">
          <img preload :src="dbConfig.default_product_image" :alt="getAlt(-1)" loading="lazy"/>
        </div>
      </div>

      <div class="more-photo" v-if="images.length > visibleThumbnails"><a @click="show">{{ $t('show_more') }}</a></div>
    </div>

    <div class="photo-main" :class="{'empty': !images.length}">
      <img preload v-if="images.length" :src="getImageUrl(images[index])" @click="show" :alt="getAlt(index)" loading="lazy"/>
      <img preload v-else-if="dbConfig.default_product_image" :src="dbConfig.default_product_image" :alt="getAlt(-1)" loading="lazy"/>
    </div>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import {directive as viewer} from 'v-viewer';

const _visibleThumbnails = 4;

// {name} для {maker} {model-n}
// {name} {oe-n}
// {name} каталог запчастей для {vehicle_type}
// {name} каталог запчастей для {vehicle_type} {category}


export default {
  props: ['product', 'dbConfig', 'productProperties'],
  directives: {
    viewer: viewer(),
  },
  data() {
    return {
      index: 0,
      alt_templates: [],
    }
  },
  computed: {
    productLocaleData() {
      return this.product?.product_translations?.find(x => x.language.slug === this.$i18n.locale) || {};
    },
    images() {
      return this.product.product_images.map(x => x.image);
    },
    visibleThumbnails() {
      return _visibleThumbnails;
    },
    viewerOptions() {
      return {
        movable: false,
        title: false,
        toolbar: {
          prev: true,
          next: true,
        },
        viewed: (e) => {
          this.index = e.detail.index;
        },
        zoomable: false,
      };
    },
  },
  created(){
    this.alt_templates = []
    if (this.$i18n.locale === 'ru'){
      if (process.env.VENDOR === 'wetz'){
        this._fill_alt_tmpls_wetz()
      } else if (process.env.VENDOR === 'wellfar'){
        this._fill_alt_tmpls_wellfar()
      }
    }
  },
  methods: {
    _fill_alt_tmpls_wetz(){
      const makers = this.getPropValues('Производитель двигателя')
      const maker = Array.isArray(makers) ? makers[0] : makers
      const category = this.getCategoryLocaleData()?.name || ''
      const models = this.getPropValues('Модель двигателя')
      const oems = this.getPropValues('OE-номер')
      const alts = (this.dbConfig.seo_product_translations.find(x => x.language.slug === this.$i18n.locale) || {})?.seo_alt_img.trim();
      if(alts){
        alts.split("\n").forEach((tmpl) => {
          let res = tmpl
            .replaceAll('{name}', (this.productLocaleData.name || ''))
            .replaceAll('{code}', (this.product.code || ''))
            .replaceAll('{maker}', (maker || ''))
            .replaceAll('{category}', (category || ''))

          if(res.indexOf('{model-n}') > -1){
            if(Array.isArray(models)){
              models.forEach((model) => {
                this.alt_templates.push(res.replaceAll('{model-n}', (model || '')))
              })
            }
            else{
              this.alt_templates.push(res.replaceAll('{model-n}', (models || '')))
            }
          }
          else if(res.indexOf('{oe-n}') > -1){
            if(Array.isArray(oems)){
              oems.forEach((oe) => {
                this.alt_templates.push(res.replaceAll('{oe-n}', (oe || '')))
              })
            }
            else{
            this.alt_templates.push(res.replaceAll('{oe-n}', (oems || '')))
            }
          }
          else if(res.indexOf('{') === -1){
            this.alt_templates.push(res)
          }
        })
      }
    },
    _fill_alt_tmpls_wellfar(){
      const makers = this.getPropValues('Производитель двигателя')
      let maker = Array.isArray(makers) ? makers[0] : makers
      let models = this.getPropValues('Модель двигателя')
      if (this.product.car_model_details?.length){
        maker = this.product.car_model_details[0].model.mark.name
        models = this.product.car_model_details.map(x => x.engine || x.power_kw+' kW')
      }
      const vehicle_types = this.getPropValues('Тип ТС')
      let vehicle_type_name = ''
      if (vehicle_types?.length === 1) {
        const vt = {
          'cv': 'коммерческой техники',
          'pc': 'легковых автомобилей',
        }
        vehicle_type_name = vt[vehicle_types[0]]
      }

      const oems = this.getPropValues('OE-номер')
      const category = this.getCategoryLocaleData()?.name || ''
      const alts = (this.dbConfig.seo_product_translations.find(
        x => x.language.slug === this.$i18n.locale
      ) || {})?.seo_alt_img.trim();
      if(alts){
        alts.split("\n").forEach((tmpl) => {
          let res = tmpl
            .replaceAll('{name}', (this.productLocaleData.name || ''))
            .replaceAll('{code}', (this.product.code || ''))
            .replaceAll('{maker}', (maker || ''))
            .replaceAll('{category}', (category || ''))
            .replaceAll('{vehicle_type}', (vehicle_type_name || ''))

          if(res.indexOf('{model-n}') > -1){
            if(Array.isArray(models)){
              models.forEach((model) => {
                this.alt_templates.push(res.replaceAll('{model-n}', (model || '')))
              })
            }
            else{
              this.alt_templates.push(res.replaceAll('{model-n}', (models || '')))
            }
          }
          else if(res.indexOf('{oe-n}') > -1){
            if(Array.isArray(oems)){
              oems.forEach((oe) => {
                this.alt_templates.push(res.replaceAll('{oe-n}', (oe || '')))
              })
            }
            else{
              this.alt_templates.push(res.replaceAll('{oe-n}', (oems || '')))
            }
          }
          else if(res.indexOf('{') === -1){
            this.alt_templates.push(res)
          }
        })
      }
    },
    getCategoryLocaleData(category) {
      return this.product.categories[0]?.category_translations?.find(x => x.language.slug === this.$i18n.locale) || {};
    },
    getPropertyLocaleName(prop) {
      let data = prop?.property_translations?.find(x => x.language.slug === this.$i18n.locale) || {};
      return data.name || prop.name;
    },
    getPropertyValueLocaleData(prop) {
      return this.product.product_properties?.find(
        x => x.property === prop.id && x.value && (!x.language || x.language.slug === this.$i18n.locale)
      ) || {};
    },
    getPropValues(prop_name) {
      const prop = this.productProperties?.filter(prop => this.getPropertyLocaleName(prop) === prop_name)
      if (prop?.length) {
        if (this.getPropertyValueLocaleData(prop[0]).multiple_values)
          return this.getPropertyValueLocaleData(prop[0]).multiple_values
        else
          return this.getPropertyValueLocaleData(prop[0]).value
      }
      return ''
    },
    getImageUrl(image) {
      return this.$options.filters.baseUrl(image.url);
    },
    show() {
      this.$refs['photo-viewer'].$viewer.view(this.index);
    },
    getAlt(index){
      if(index >= 0 && this.alt_templates.length > 0 && index < this.alt_templates.length){
        return this.alt_templates[index]
      }
      return this.productLocaleData.name
    }
  },
}
</script>

<i18n lang="yaml">
ru:
  show_more: 'Показать ещё'
en:
  show_more: 'Show more'
</i18n>
